var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.533,
    height: 14,
    viewBox: "0 0 20.533 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visibility_FILL0_wght400_GRAD0_opsz48",
    d: "M12.267,18.967A3.944,3.944,0,0,0,16.233,15a3.944,3.944,0,0,0-3.967-3.967A3.944,3.944,0,0,0,8.3,15a3.944,3.944,0,0,0,3.967,3.967Zm0-1.353a2.623,2.623,0,0,1-1.855-4.468,2.648,2.648,0,0,1,3.71,0,2.613,2.613,0,0,1-1.855,4.468Zm0,4.387a10.458,10.458,0,0,1-6.16-1.937A11.8,11.8,0,0,1,2,15,11.8,11.8,0,0,1,6.107,9.937,10.458,10.458,0,0,1,12.267,8a10.458,10.458,0,0,1,6.16,1.937A11.8,11.8,0,0,1,22.533,15a11.8,11.8,0,0,1-4.107,5.063A10.458,10.458,0,0,1,12.267,22ZM12.267,15Zm0,5.6a9.383,9.383,0,0,0,5.192-1.528A9.918,9.918,0,0,0,21.063,15a9.918,9.918,0,0,0-3.6-4.072,9.582,9.582,0,0,0-10.383,0A10.084,10.084,0,0,0,3.447,15a10.084,10.084,0,0,0,3.628,4.072A9.383,9.383,0,0,0,12.267,20.6Z",
    transform: "translate(-2 -8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.0f34472c4a0d4641a4d7202ecb53f10c.svg";
export { ForwardRef as ReactComponent };